import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  parsePastedText,
  parseCSV,
  parseXLSX,
  mapTableToObjects,
} from '../helpers'
import { setInterpreterRequest } from 'store/slices/interpreterRequestSlice'

export const BOMProcessor: React.FC = () => {
  const dispatch = useDispatch()
  const [rawText, setRawText] = useState('')
  const [structuredData, setStructuredData] = useState<
    Record<string, string>[]
  >([])

  const handleTableParse = (table: string[][]) => {
    const structured = mapTableToObjects(table)
    setStructuredData(structured)
    dispatch(setInterpreterRequest({ bomData: structured }))
  }

  const handleTextInput = () => {
    const table = parsePastedText(rawText)
    handleTableParse(table)
  }

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (!file) return

    let table: string[][] = []
    if (file.name.endsWith('.csv')) {
      table = await parseCSV(file)
    } else if (file.name.endsWith('.xlsx')) {
      table = await parseXLSX(file)
    }

    setRawText('')
    handleTableParse(table)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleTextInput()
    }
  }

  return (
    <div className="mb-6">
      <textarea
        value={rawText}
        onChange={(e) => setRawText(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Paste BOM (tab-separated or CSV-style)"
        rows={6}
        className="w-full p-2 border border-gray-300 rounded mb-2"
      />

      <input type="file" accept=".csv,.xlsx" onChange={handleFileUpload} />
    </div>
  )
}
